import { APIClient } from '../lib/apiHelper';
import { getItem } from '../lib/localstorage';

const { get, post, put } = new APIClient();

export default {
	/**
	 * 이메일 인증
	 * @method GET
	 * @param {STRING} email
	 */
	emailAuth: (email) => get(`/auth/email-auth?email=${email}`),
	/**
	 * 이메일 인증 코드 확인
	 * @method GET
	 * @param {STRING} email
	 * @param {STRING} code
	 */
	emailAuthConfirm: (email, code) => get(`/auth/email-auth-confirm?email=${email}&code=${code}`),
	/*
	 *작성자:장윤석
	 *작성일:22.09.20
	 *변경일:22.09.20
	 *목적: 아이디 중복 검사
	 */
	isUserIdExist: (userId) => get(`/auth/isUserIdExist?userid=${userId}`),
	/**
	 * 이메일 존재 여부 확인
	 * @method POST
	 * @param {STRING} email
	 */
	isExistEmail: (email) => get(`/auth/is-exist-email?email=${email}`),
	/**
	 * 회원 가입
	 * @method POST
	 * @param {OBJECT} user
	 * =========================
	 * @param {STRING} email
	 * @param {STRING} password
	 * @param {STRING} name
	 */
	/*
	 *작성자:김현진
	 *작성일:22.09.07
	 *변경일:22.09.07
	 *목적: user 등록
	 */
	register: (user) => put('/user/register/debriefer', user),
	/*
	*작성자:김현진
	*작성일:22.09.07
	*변경일:22.09.07
	*목적: user 목록, (파라미터 없이 호출시 전체 리스트, 파라미터:?regid=1 호출시 regid만 )
          페이징 가능하도록 전체리스트와 offset으로 추가 예정
	*/
	userlist: (params) => get(`/user/list${  params ? '?'+new URLSearchParams(params).toString() : ''}`),
	grouplist: () => get(`/group/list`),

	userListAll: () => get(`/auth/userlist/all`),
	/*
	 *작성자:김현진
	 *작성일:22.09.07
	 *변경일:22.09.07
	 *목적: user 수정 -> 수정후 frontend userlist 업데이트 필요
	 */
	userModify: (user) => post('/auth/userModify', user),
	userModify2: (user) => post('/auth/userModify2', user),
	/*
	 *작성자:장윤석
	 *작성일:22.09.21
	 *변경일:22.09.21
	 *목적: 유저 삭제
	 */
	userDelete: (regid) => get(`/auth/userDelete?regid=${regid}`),
	/**
	 * 로그인
	 * @method POST
	 * @param {STRING} email
	 * @param {STRING} password
	 */
	login: (user) => post('/auth/login', user),
	logout: () => get('/auth/logout'),
	beforeSession: () => get('/auth/beforeSession'),
	/*
	 *작성자:장윤석
	 *작성일:22.10.07
	 *변경일:22.10.07
	 *목적: 내 정보 가져오기
	 */
	me: () => get(`/auth/me`),
	/**
	 * 비밀번호 찾기 이메일 인증
	 * @method GET
	 * @param {STRING} email
	 */
	forgetPassword: (email) => get(`/auth/forget-password?email=${email}`),
	/**
	 * 비밀번호 찾기 이메일 인증
	 * @method GET
	 * @param {STRING} email
	 * @param {STRING} code
	 */
	forgetPasswordConfirm: (email, code) =>
		get(`/auth/forget-password-confirm?email=${email}&code=${code}`),
	/**
	 * 비밀번호 찾기 이메일 인증
	 * @method GET
	 * @param {STRING} email
	 * @param {STRING} password
	 */
	changePassword: async (UserID, password) => {
		const dummy = password.split('').reverse().join('');
		const passwordData = { UserID, password, dummy };

		return put('/auth/change-password', passwordData);
	},
	SSOLogin: (data) => get('/sso/sso_assert?' + Object.entries(data).map(e => e.join('=')).join('&'), {}, '/exsignon'),
	SSOLogout: (data) => post('/sso/logout', data, '/exsignon'),
	uploadProfile: (data) => post('/auth/uploadProfile', data),
	deleteProfile: () => get('/auth/deleteProfile'),
	roles: () => get('/role/userid'),
	download: async (userId, historyId, premium) => {
		return await fetch('https://api.icru.co.kr/api/v1/download/' + userId + '/' + historyId + (premium ? ('/' + premium) : ''), {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				'client-id': 'kr.co.icru',
				'user-id': userId,
				'authorization': 'Bearer ' + getItem('access-token'),
			}
		})
	},
	groupDownload: async (code, userId) => {
		return await fetch('https://api.icru.co.kr/api/v1/group/download/' + code, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				'client-id': 'kr.co.icru',
				'user-id': userId,
				'authorization': 'Bearer ' + getItem('access-token'),
			}
		})
	},
	groupCodeGenerate: async (groupName) => post('/group/code/generate', groupName),
	groupUserList: async (code) => post('/group/user/list', {code}),
	report: async (userId, historyId) => post('/report', {userId, historyId}),
	premium: async (userId, historyId) => post('/report/premium', { userId, historyId }),
	setEnd: async (user) => post('/group/end', user),
};
